import { Box, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

import {
  FLEXIBLE_PROPERTIES_VIEW_MODE,
  type FlexiblePropertiesViewMode,
} from '../../../constants/FlexiblePropertiesConstants';

type Props = {
  viewMode: FlexiblePropertiesViewMode;
  onViewModeChange: (viewMode: FlexiblePropertiesViewMode) => void;
  isLoading?: boolean;
};

const equalToggleButtonCss = { flex: '1 0 0', minWidth: 0 } as const;

export const ViewMode = ({ viewMode, onViewModeChange, isLoading = false }: Props) => {
  const handleViewModeChange = (value: string | Array<string>) => {
    const selectedViewMode = Array.isArray(value) ? value[0] : value;
    onViewModeChange(selectedViewMode as FlexiblePropertiesViewMode);
  };

  return (
    <Box
      css={{
        flexShrink: 0,
        marginInlineStart: { xl: 'auto' },
        width: { base: '100%', xl: 'auto' },
      }}
    >
      <ToggleButtonGroup
        aria-label="Filter property list by view"
        size="sm"
        value={viewMode}
        onValueChange={handleViewModeChange}
        disabled={isLoading}
        css={{ width: { base: '100%', xl: '272px' } }}
        data-testid="FlexiblePropertiesPage-Filters-ViewMode"
      >
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.PROPERTIES} css={equalToggleButtonCss}>
          Properties
        </ToggleButton>
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.UNITS} css={equalToggleButtonCss}>
          Units
        </ToggleButton>
        <ToggleButton value={FLEXIBLE_PROPERTIES_VIEW_MODE.BOTH} css={equalToggleButtonCss}>
          Both
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
